import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ddf1faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "h2" }
const _hoisted_4 = { class: "flex flex-lg-row flex-column result-buttons" }
const _hoisted_5 = { class: "result-buttons__button-group flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_7 = { class: "result-buttons__button-group flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row py-6" }
const _hoisted_11 = { class: "col-12 px-0 print-exact-color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_MethodSelection = _resolveComponent("MethodSelection")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, {
      showCalculationRow: true,
      "use-one-column": true,
      "header-padding": 0
    }, {
      firstColumn: _withCtx(() => []),
      _: 1
    }),
    _createVNode(_component_SharedHeader, {
      tabMenu: _ctx.menu,
      showCalculationRow: ""
    }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_1, [
            _createVNode(_component_SimpleText, { "text-key": "results.headerTitle" }),
            _createTextVNode(" " + _toDisplayString(_ctx.calculation.calculationPurpose.name) + ": ", 1),
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.doPrettify(this.totalEmission)) + " ", 1),
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString("results.tonCo2")]
              ])
            ])
          ])
        ])
      ]),
      secondColumn: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              id: "`result-export-excel-link`",
              class: "button button-secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
            }, [
              _hoisted_6,
              _createVNode(_component_SimpleText, { "text-key": "results.downloadExcelButtonText" })
            ]),
            _createVNode(_component_Tooltip, {
              style: `vertical-align: middle;`,
              text: this.downloadExcelTooltip,
              size: "lg"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              id: `result-print-link`,
              class: "button button-secondary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadPdf && _ctx.handleDownloadPdf(...args)))
            }, [
              _hoisted_8,
              _createVNode(_component_SimpleText, { "text-key": "results.printButtonText" })
            ]),
            _createVNode(_component_Tooltip, {
              style: `vertical-align: middle;`,
              text: this.printTooltip,
              size: "lg"
            }, null, 8, ["text"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["tabMenu"]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_MethodSelection, {
            results: _ctx.results,
            onMethodSelectionChanged: _ctx.doRecalculate,
            onMethodSelectionChangedRFI: _ctx.doRecalculateRFI
          }, null, 8, ["results", "onMethodSelectionChanged", "onMethodSelectionChangedRFI"]),
          _createVNode(_component_router_view, { results: _ctx.results }, null, 8, ["results"])
        ])
      ])
    ])
  ], 64))
}